import { useMemo } from 'react';

import { useFormState } from 'react-final-form';

import { usePetitionReportAbuseContext } from '../../../../shared/context';
import type { FieldType, FormValues, Question } from '../../../../shared/types';
import { getSubCategoriesOrQuestions, getSubSubCategoriesOrQuestions } from '../../../../shared/utils';

type Result = ModelHookResult<{
	parent: FieldType | undefined;
	questions: readonly Question[];
}>;

export function useQuestionField(): Result {
	const { type } = usePetitionReportAbuseContext();
	const {
		values: { category, subCategory },
	} = useFormState<FormValues>({
		subscription: { values: true },
	});

	const data = useMemo(() => {
		if (subCategory) {
			const subSubCategoriesOrQuestions = getSubSubCategoriesOrQuestions(type, subCategory);
			return {
				parent: subCategory,
				questions: subSubCategoriesOrQuestions.type === 'question' ? subSubCategoriesOrQuestions.value : [],
			};
		}

		if (category) {
			const subCategoriesOrQuestions = getSubCategoriesOrQuestions(type, category);
			return {
				parent: category,
				questions: subCategoriesOrQuestions.type === 'question' ? subCategoriesOrQuestions.value : [],
			};
		}
		return {
			parent: undefined,
			questions: [],
		};
	}, [category, subCategory, type]);
	return { data };
}
